module.exports = __webpack_public_path__ + "media/images/icons/clear-8e73867ef6ce6bb46320b164be18fb93.svg";